import { html, ref, repeat } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { ContractsTab } from './contracts-summaries';

export const ContractsTabTemplate = html<ContractsTab>`
  <div class="form-control required">
    <label>General Equipment Supply Agreement</label>
    <zero-select
      ${ref('equipmentSupplyAgreements')}
      :value=${sync((x) => x.equipmentSupplyAgreementsValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Engineering, procurement and construction ("EPC") Agreement</label>
    <zero-select
      ${ref('epcAgreement')}
      :value=${sync((x) => x.epcAgreementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Operation & Maintenance Agreement</label>
    <zero-select
      ${ref('operationMaintenanceAgreement')}
      :value=${sync((x) => x.operationMaintenanceAgreementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Management Services Agreement</label>
    <zero-select
      ${ref('managementServicesAgreement')}
      :value=${sync((x) => x.managementServicesAgreementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Feasibility Study</label>
    <zero-select
      ${ref('feasibilityStudy')}
      :value=${sync((x) => x.feasibilityStudyValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>System Impact Study</label>
    <zero-select
      ${ref('systemImpactStudy')}
      :value=${sync((x) => x.systemImpactStudyValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Facilities Study</label>
    <zero-select
      ${ref('facilitiesStudy')}
      :value=${sync((x) => x.facilitiesStudyValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Interconnection Agreement</label>
    <zero-select
      ${ref('interconnectionAgreement')}
      :value=${sync((x) => x.interconnectionAgreementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>BoP Agreement</label>
    <zero-select
      ${ref('bopAgreement')}
      :value=${sync((x) => x.bopAgreementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Construction Agreement</label>
    <zero-select
      ${ref('constructionAgreement')}
      :value=${sync((x) => x.constructionAgreementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>

    <div class="form-control required">
      <label>Energy Management Agreement</label>
      <zero-select
        ${ref('energyManagementAgreement')}
        :value=${sync((x) => x.energyManagementAgreementValue)}
        class="input-control"
      >
        ${repeat(
          (x) => x.statusEnum,
          html`
            <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
          `
        )}
      </zero-select>
    </div>
  </div>
`;
